export const animeScoreTags = [
  // 上方バイアス
  { id: 1, label: '趣味嗜好補正' },
  { id: 2, label: '思い出補正' },
  { id: 3, label: 'IP・シリーズ補正' },
  { id: 4, label: '制作補正' },
  { id: 5, label: '原作補正' },
  { id: 6, label: '声優補正' },
  { id: 7, label: 'エントリー補正' },
  { id: 8, label: 'コンテクスト補正' },
  { id: 10, label: '期待値補正' },
  { id: 0, label: 'その他の上方バイアス' },
  // 下方バイアス (思い出・IP/シリーズは上方のみ)
  { id: 31, label: '趣味嗜好補正' },
  { id: 34, label: '制作補正' },
  { id: 35, label: '原作補正' },
  { id: 36, label: '声優補正' },
  { id: 37, label: 'エントリー補正' },
  { id: 38, label: 'コンテクスト補正' },
  { id: 40, label: '期待値補正' },
  { id: 9, label: 'その他の下方バイアス' },
];
